import { generateRandomString } from '@aws-amplify/core/internals/utils';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const generateState = () => {
    return generateRandomString(32);
};

export { generateState };
//# sourceMappingURL=generateState.mjs.map
